import { render, staticRenderFns } from "./ModalPropriedadesFreteCidade.vue?vue&type=template&id=28358949"
import script from "./ModalPropriedadesFreteCidade.vue?vue&type=script&lang=js"
export * from "./ModalPropriedadesFreteCidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports